<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb" style="border-radius:0">
        <li class="breadcrumb-item">
          <router-link v-bind:to="'/' + this.$i18n.locale + '/' + property.slug + '/' + $t('bookings.url')">
            {{ $t('bookings.name') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-bind:to="'/' + this.$i18n.locale + '/' + $t('bookings.url') + '/' + $route.params.bookingId">
            {{ $t('booking') }} {{ invoice.booking.night.first | date }} - {{ invoice.booking.night.last | checkOut }}
          </router-link>
        </li>
        <li class="breadcrumb-item" aria-current="page">{{ $t('save') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">{{ $t('invoice') }}</h1>
          <p class="lead text-muted">
            <span v-if="$route.params.invoiceId">{{$route.params.invoiceId}}</span>
            <span v-else>{{ $t('save') }}</span>
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-10 border-right">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
              <form id="invoiceForm">

                <h5>{{ $t('information.invoice') }}</h5>

                <div class="alert alert-danger" role="alert" v-if="alerts.length">
                  <div v-for="alert in alerts">
                    <div v-for="key in Object.keys(alert)">
                      <div v-for="message in alert[key]" class="d-flex align-items-center">
                        <div>{{message}}</div>
                        <div v-if="key == 'price'">
                          <router-link to="/sl/inter-es/cene/ustvari" class="ml-5 btn btn-danger btn-sm">Create Price</router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <div class="row">
                    <div class="col-md-6">
                      <label for="issuedDate">{{ $t('issued.date') }}</label>
                      <ValidationProvider name="issued date" vid="issued.date" rules="required" v-slot="{ errors }">
                        <date-picker :input-props='{
                                       class: "form-control " + (errors[0] ? "is-invalid" : ""),
                                     }'
                                     :firstDayOfWeek="2"
                                     v-model="issuedDate"
                                     :popover="{ placement: 'bottom', visibility: 'click', 'expanded': true }"
                                     >
                        </date-picker>
                        <span class="text-danger">{{errors[0]}}</span>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-6">
                      <label for="invoice.issued.time">{{ $t('issued.time') }}</label>
                      <ValidationProvider name="issued time" vid="issued.time" rules="required" v-slot="{ errors }">
                        <input class="form-control" v-model="invoice.issued.time" :class="{ 'is-invalid': errors[0] }">
                        <span class="text-danger">{{errors[0]}}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-clean table-vcenter" style="width:100%;">
                    <tr>
                      <th>{{ $t('title') }}</th>
                      <th>{{ $t('quantity') }}</th>
                      <th>{{ $t('price') }}</th>
                      <th>{{ $t('tax') }}</th>
                      <th>{{ $t('fullPrice') }}</th>
                      <th>{{ $t('discount') }}</th>
                      <th>{{ $t('total.net') }}</th>
                    </tr>

                    <tr v-for="service in services">
                      <td>
                        <ValidationProvider name="service.title" v-bind:vid="String(service.title)" rules="required" v-slot="{ errors }">
                          <input class="form-control" v-model="service.title">
                          <span class="text-danger">{{errors[0]}}</span>
                        </ValidationProvider>
                      </td>
                      <td>
                        <ValidationProvider name="service.quantity" v-bind:vid="String(service.quantity)" rules="required" v-slot="{ errors }">
                          <input class="form-control" v-model="service.quantity">
                          <span class="text-danger">{{errors[0]}}</span>
                        </ValidationProvider>
                      </td>
                      <td>{{ service | net }}€
                       
                      </td>
                      <td>{{ service | tax }}€
                      </td>
                      <td>
                       <ValidationProvider name="service.price" v-bind:vid="String(service.price)" rules="required" v-slot="{ errors }">
                          <input class="form-control" v-model="service.price">
                          <span class="text-danger">{{errors[0]}}</span>
                        </ValidationProvider>
                      </td>
                      <td>{{ service | discount }}%</td>
                      <td>{{ service | totalValue }}€
                      </td>
                    </tr>
                    
                  </table>
                </div>

                <br>
                <div>
                  <strong>{{ $t('total.net') }}:</strong>
                  {{  price.net }}€
                </div>

                <div>
                  <strong>{{ $t('total.tax') }}:</strong>
                  {{ price.tax }}€
                </div>

                <div>
                  <strong>{{ $t('total.full') }}:</strong>
                  {{ price.full }}€
                </div>
                <br>
                <br>

                <h5>{{ $t('information.payment') }}</h5>

                <div class="form-group" v-for="(paymentMethod, index) in invoice.paymentMethods">
                  <div class="row">
                    <div class="col-md-7">
                      <label for="invoice.paymentMethods[index]._id">{{ $t('title') }}</label>
                      <ValidationProvider name="payment method title" v-bind:vid="'paymentMethods.' + index + '._id'" rules="required" v-slot="{ errors }">
                        <select class="form-control" v-model="invoice.paymentMethods[index]._id">
                          <option v-for="method in paymentMethods" v-bind:value="method._id">{{method.title}}</option>
                        </select>
                        <span class="text-danger">{{errors[0]}}</span>
                      </ValidationProvider>
                    </div>
                    <div class="col-6 col-md-4">
                      <label for="invoice.paymentMethods[index].amount">{{ $t('amount') }}</label>
                      <ValidationProvider name="payment method amount" v-bind:vid="'paymentMethods.' + index + '.amount'" rules="required" v-slot="{ errors }">
                        <input class="form-control" v-model="invoice.paymentMethods[index].amount">
                        <span class="text-danger">{{errors[0]}}</span>
                      </ValidationProvider>
                    </div>
                    <div class="col-6 col-md-1">
                      <label><br></label>
                      <button :disabled="index == 0" type="button" @click="invoice.paymentMethods.splice(index, 1)" class="btn btn-block btn-secondary">-</button>
                    </div>
                  </div>
                </div>
                <button type="button" @click="invoice.paymentMethods.push({})" class="btn btn-secondary">{{ $t('addPaymentMethod') }}</button>

                <div class="d-flex w-100">

                  <div class="btn-group btn-group-justified d-flex w-100 pb-5 pt-4">
                    <button type="button" name="save" class="btn btn-primary flex-grow-1" @click="handleSubmit(submit)" :disabled="alerts.length > 0">
                      {{ $t('save') }}
                    </button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import moment from 'moment';

export default {
  name: 'CreateInvoice',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name){
        vm.from = from.fullPath
      }else{
        vm.from = null
      }
    });
  },
  data: () => ({
    issuedDate: '',
    from: null,
    property: {},
    alerts: [],
    paymentMethods: [
    ],
    price: {
      full: 0,
      net: 0,
      tax: 0
    },
    services: [],
    invoice: {
      issued: {
        date: "",
        time: ""
      },
      paymentMethods: [{}],
      booking: {
        _id: "",
        night: {
          first: "",
          last: ""
        }
      },
      services: []
    }
  }),
  components: {
    DatePicker
  },
  watch: {
    'issuedDate': function(val, oldVal) {
      this.invoice.issued.date = moment(val).format('YYYY-MM-DD')
    },
    'services': {
      handler: function(newVal, oldVal) {
        this.calculatePrice();
      },
      deep: true // Watch changes within the array
    }
  },
  filters: {
    price: function(service){
      return Math.round(service.fullPrice * (100 / (100 + service.taxRate)) * 100 + Number.EPSILON) / 100;
    },
    tax: function(service){
      return Math.round(service.price * (service.taxRate / (100 + service.taxRate)) * 100 + Number.EPSILON) / 100;
    },
    discount: function(service){
      return Math.round((1 - (service.price / service.fullPrice)) * 100 * 100 + Number.EPSILON) / 100;
    },
    total: function(service){
      return Math.round((service.price * service.quantity * (100 / (100 + service.taxRate)) *  100) + Number.EPSILON) / 100;
    },
    date: function(date){
      if(!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    checkOut: function(date){
      if(!date) return '';
      return moment(date).add(1, 'days').format('DD/MM/YYYY');
    },
    net: function(service){
      return Math.round(service.price * (100 / (100 + service.taxRate)) * 100 + Number.EPSILON) / 100;
    },
    totalValue: function(service){
      return service.quantity * service.price;
    },
    totalNet: function(services){
      services.forEach(service => {
        price.full += service.quantity * service.price;
      })
      return price.full;
    }
  },
  created(){
    if(this.$route.params.bookingId){
      let url = '/bookings/' + this.$route.params.bookingId + '/invoice';
      fetch(process.env.VUE_APP_API + url, {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        if(!response.error){
          this.services = response.services;
          this.property = this.$store.state.host.properties.find(p => p.rooms.find(r => r._id == response.booking.room._id));
          this.loadPaymentMethods();
          if(response.paymentMethods && response.paymentMethods.length) this.invoice.paymentMethods = response.paymentMethods;
          this.invoice.booking._id = response.booking._id;
          this.invoice.booking.night.first = response.booking.night.first;
          this.invoice.booking.night.last = response.booking.night.last;
          this.invoice.issued.date = response.issued.date;
          this.invoice.issued.time = response.issued.time;
          this.invoice.paymentMethods[0].amount = response.booking.price;
          this.issuedDate = moment(response.issued.date).toDate();

          this.services.forEach(service => {
            this.price.net += Math.round((service.price * (100 / (100 + service.taxRate))*  100) + Number.EPSILON) / 100;
            this.price.tax += Math.round((service.price * (service.taxRate / (100 + service.taxRate))*  100) + Number.EPSILON) / 100;
            this.price.full += service.quantity * service.price;
            service.fullPrice = service.price;
          });
        }else{
          this.alerts.push(response.error.messages)
        }
      })
    }
  },
  methods: {
    submit: function(){
      this.invoice.services = this.services;
      return fetch( process.env.VUE_APP_API + '/invoices', {
        method : 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify(this.invoice)
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          if(this.from){
            this.$router.push(this.from);
          }else{
            this.$router.push('/' + this.$i18n.locale + '/' + this.property.slug + '/' + $t('invoices'));
          }
        }else{
          this.$refs.form.setErrors(response.error.messages);
        }
      });
    },
    loadPaymentMethods: function(){
      return fetch( process.env.VUE_APP_API + '/payment-methods?property._id=' + this.property._id, {
        method : 'get',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          this.paymentMethods = response;
        }else{
          this.alerts.push(response.error.messages)
        }
      });
    },
    calculatePrice() {
      let totalPrice = 0;
      let totalNetPrice = 0;
      let totalTaxes = 0;
      for (const service of this.services) {
        totalNetPrice += Math.round((service.quantity * service.price * (100 / (100 + service.taxRate))*  100) + Number.EPSILON) / 100;
        totalTaxes += Math.round((service.quantity * service.price * (service.taxRate / (100 + service.taxRate))*  100) + Number.EPSILON) / 100;
        totalPrice += service.quantity * service.price;
        service.fullPrice = service.price;
      }
      this.price.net = totalNetPrice;
      this.price.tax = totalTaxes;
      this.price.full = totalPrice;
      this.invoice.paymentMethods[0].amount = totalPrice;
    }

  }
}
</script>

<i18n>
{
  "en": {
    "bookings": {
      "name": "Bookings",
      "url": "bookings"
    },
    "booking": "Booking",
    "invoice": "Invoice",
    "invoices": "invoices",
    "create": "create",
    "information": {
      "invoice": "Invoice Information",
      "payment": "Payment Information"
    },
    "issued": {
      "date": "Issued Date",
      "time": "Issued Date"
    },
    "title": "Title",
    "qantity": "Quantity",
    "price": "Price",
    "tax": "Tax",
    "fullPrice": "Price with Tax",
    "discount": "Discount",
    "total": {
      "net": "Total (net)",
      "tax": "Total Tax",
      "full": "Total With Tax"
    },
    "amount": "Amount",
    "save": "Create invoice",
    "addPaymentMethod": "Add Payment Method"
  },
  "sl": {
    "bookings": {
      "name": "Rezervacije",
      "url": "rezervacije"
    },
    "booking": "Rezervacija",
    "invoice": "Račun",
    "invoices": "racuni",
    "create": "ustvari",
    "information": {
      "invoice": "Podatki računa",
      "payment": "Vrsta plačila"
    },
    "issued": {
      "date": "Datum izdaje",
      "time": "Čas izdaje"
    },
    "title": "Naziv",
    "quantity": "Količina",
    "price": "Cena",
    "tax": "Davek",
    "fullPrice": "Cena z davkom",
    "discount": "Popust",
    "total": {
      "net": "Skupaj (neto)",
      "tax": "Skupaj DDV",
      "full": "Skupaj z DDV"
    },
    "amount": "Znesek",
    "save": "Ustvari račun",
    "addPaymentMethod": "Dodaj plačilno sredstvo"
  }
}
</i18n>
